module.exports = __webpack_public_path__ + "img/bottom3.682eba07.jpg";